import { AppConfig } from "~/AppConfig";

import { createSecurityWorker } from "../api/workers";
import { Api, ApiConfig, HttpClient } from "./ApiProduct";

type SecurityDataType = unknown;
const API_PATH = "/api/v3/payments";
export type ApiClient = Api<SecurityDataType>;

const HttpParams = {
  baseApiParams: {
    secure: true,
    format: "json",
  },
  securityWorker: createSecurityWorker(),
  baseUrl: (AppConfig.API_URL + API_PATH) as string,
} satisfies ApiConfig;

export const HttpApiClientWithParams = new HttpClient(HttpParams);

export const apiProductClient = new Api(HttpApiClientWithParams);
